module.exports = __webpack_public_path__ + "stylesheets/video-folder-breadcrumb_42fb50260c84c73669d30b00c837724e.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/folder/video-folder-breadcrumb.less
// module id = OjHm
// module chunks = 151